import "./Contact.css";
import Cta from "./Cta";
import FAQSection from "./FAQSection";
import { Helmet } from 'react-helmet-async';
import Footer from "./Footer";

import React, { useEffect, useState,useRef } from 'react';
import { X, Calendar, Clock, User, Mail } from 'lucide-react';
import { useLocation } from "react-router-dom";
import RegistrationForm from "./components/RegistrationForm";

const Contact = () => {

  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const formSectionRef = useRef(null)

  // 2. scroll handler
  const scrollToForm = () => {
    formSectionRef.current?.scrollIntoView({ behavior: 'smooth' })
  }

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isSuccessPopupOpen, setIsSuccessPopupOpen] = useState(false);
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    date: '',
    time: '',
    message: ''
  });
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'Required';
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Required';
    }

    if (!formData.date) {
      newErrors.date = 'Required';
    }

    if (!formData.time) {
      newErrors.time = 'Required';
    }

    return newErrors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm();

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    // Handle form submission here
    console.log('Form submitted:', formData);

    // Close the form popup and show success popup
    setIsPopupOpen(false);
    setIsSuccessPopupOpen(true);

    // Reset form and errors
    setFormData({
      firstName: '',
      lastName: '',
      date: '',
      time: '',
      message: ''
    });
    setErrors({});
  };

  const openPopup = () => {
    setIsPopupOpen(true);
    setErrors({}); // Clear errors when opening popup
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setErrors({}); // Clear errors when closing popup
  };

  const closeSuccessPopup = () => {
    setIsSuccessPopupOpen(false);
  };


  return (
    <>

      <Helmet>
        <meta name="title" content="Contact | Get Next Visa - AI Powered Student Visa Report" />
        <title>Contact | Get Next Visa - AI Powered Student Visa Report</title>
        <meta name="description" content="Get personalized, AI-powered visa reports. Discover the best countries and colleges for your study abroad journey." />
      </Helmet>

      {/* section 1 */}
      <div className="work">
        <div className="work-badge">We're Here to Help</div>
        <div className="work-content">
          <h2>Let's Get In Touch</h2>
          <p>Have questions about our services? Need help with your immigration planning?
            Our team is here to help you every step of the way.</p>
        </div>
      </div>


      {/* section 2 */}

      {/* <div className="registration-page">
        <div className="registration-container">
          <div className="form-sectionn">
            <div className="form-header">

              <h1>Or fill out the form below</h1>
              <p>We'll get back to you within 24 hours.</p>
            </div>
            <form>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="inquiry-purpose">
                    Inquiry Purpose <span className="required">*</span>
                  </label>
                  <select id="inquiry-purpose" required="">
                    <option value="" disabled="" selected="">
                      Choose one option...
                    </option>
                    <option value="general">General Inquiry</option>
                    <option value="support">Technical Support</option>
                    <option value="sales">Refund Inquiry</option>
                    <option value="partnership">Partnership</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <label htmlFor="description">
                    Description that fits you <span className="required">*</span>
                  </label>
                  <select id="description" required="">
                    <option value="" disabled="" selected="">
                      Choose one option...
                    </option>
                    <option value="small-business">Parent</option>
                    <option value="enterprise">Enterprise</option>
                    <option value="student">Student</option>
                  </select>
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="full-name">
                    Full Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    id="full-name"
                    placeholder="Enter your full name..."
                    required=""
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">
                    Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Enter your email address..."
                    required=""
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="organization">Organization</label>
                  <input
                    type="text"
                    id="organization"
                    placeholder="Enter your organization..."
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="phone">Phone Number</label>
                  <input
                    type="tel"
                    id="phone"
                    placeholder="Enter your phone number..."
                  />
                </div>
              </div>
              <div className="form-group full-width">
                <label htmlFor="message">
                  Message <span className="required">*</span>
                </label>
                <textarea
                  id="message"
                  placeholder="Enter your message here..."
                  required=""
                  defaultValue={""}
                />
              </div>
              <button type="submit" className="submit-btn">
                Submit Form
                <img src="/photos/hy.png" alt="USA Visa Requirements" />
              </button>
            </form>
          </div>
          <div className="illustration-section">
          </div>
        </div>
      </div> */}



      <div ref={formSectionRef}>
        <RegistrationForm />
      </div>



      {/* section 3 */}

      <section className="why-section1">
        <div className="why-container1 container">
          <div className="feats-grid1">
            <div className="feat-card1 fade-in" >
              <div className="feat-icons">
                <img src="/photos/to1.png" alt="USA Visa documents required" loading="lazy" />
              </div>
              <h3 className="feat-title1">Call Us</h3>
              <p className="feat-description1">
                India: +91 7888818668 <br />
                International: +1 (647) 992 6147
              </p>

            </div>
            <div className="feat-card1 fade-in" >
              <div className="feat-icons">
                <img src="/photos/to2.png" alt="ilets India" loading="lazy" />
              </div>
              <h3 className="feat-title1">Email Us</h3>
              <p className="feat-description1">
                support@getnextvisa.com <br />
                partner@getnextvisa.com
              </p>
            </div>
            <div className="feat-card1 fade-in">
              <div className="feat-icons">
                <img src="/photos/to3.png" alt="ilets exam India" loading="lazy" />
              </div>
              <h3 className="feat-title1">Visit Us</h3>
              <p className="feat-description1">
                IT City Chandigarh, India <br />
                Business Hours: 9 AM - 6 PM IST
              </p>
            </div>

          </div>
        </div>
      </section>


      {/* section 4 */}
      <div id="faq"></div>
      <FAQSection />



      {/* section 5 */}

      <div className="schedule-call-container">
        <div className="still-main">
          <div className="still">
            <div className="still-1">
              <h2>Still have questions?</h2>
              <p>Can't find the answer you're looking for? Our support team is here to help you with any questions.</p>
            </div>
            <div className="button-container">
              <button className="chat-btn" onClick={scrollToForm}>
                <Mail size={20} /> Chat with Support
              </button>
              <button className="schedule-btn" onClick={scrollToForm}>
                <Calendar size={20} /> Schedule a Call
              </button>
            </div>
          </div>
        </div>

        {/* Popup Overlay */}
        {isPopupOpen && (
          <div className="popup-overlay" onClick={closePopup}>
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="popup-headerr">
                <h3>Schedule a Call</h3>
                <button className="close-btnn" onClick={closePopup}>
                  <X size={24} />
                </button>
              </div>

              <div className="popup-form">
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="firstName">First Name *</label>
                    <div className="input-wrapper">
                      <User size={18} className="input-icon" />
                      <input
                        type="text"
                        id="firstName"
                        name="firstName"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        placeholder="Enter your first name"
                        className={errors.firstName ? 'error' : ''}
                      />
                    </div>
                    {errors.firstName && (
                      <div className=" err-massage">
                        {errors.firstName}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="lastName">Last Name *</label>
                    <div className="input-wrapper">
                      <User size={18} className="input-icon" />
                      <input
                        type="text"
                        id="lastName"
                        name="lastName"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        placeholder="Enter your last name"
                        className={errors.lastName ? 'error' : ''}
                      />
                    </div>
                    {errors.lastName && (
                      <div className=" err-massage">
                        {errors.lastName}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="date">Preferred Date *</label>
                    <div className="input-wrapper">
                      <Calendar size={18} className="input-icon" />
                      <input
                        type="date"
                        id="date"
                        name="date"
                        value={formData.date}
                        onChange={handleInputChange}
                        min={new Date().toISOString().split('T')[0]}
                        className={errors.date ? 'error' : ''}
                      />
                    </div>
                    {errors.date && (
                      <div className=" err-massage">
                        {errors.date}
                      </div>
                    )}
                  </div>

                  <div className="form-group">
                    <label htmlFor="time">Preferred Time *</label>
                    <div className="input-wrapper">
                      <Clock size={18} className="input-icon" />
                      <input
                        type="time"
                        id="time"
                        name="time"
                        value={formData.time}
                        onChange={handleInputChange}
                        className={errors.time ? 'error' : ''}
                      />
                    </div>
                    {errors.time && (
                      <div className=" err-massage">
                        {errors.time}
                      </div>
                    )}
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Message (Optional)</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    placeholder="Tell us what you'd like to discuss..."
                    rows="4"
                  ></textarea>
                </div>

                <div className="form-actions">
                  <button type="button" className="cancel-btn" onClick={closePopup}>
                    Cancel
                  </button>
                  <button type="submit" className="submit-btnn" onClick={handleSubmit}>
                    Schedule Call
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Success Popup */}
        {isSuccessPopupOpen && (
          <div className="popup-overlay" onClick={closeSuccessPopup}>
            <div className="success-popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="success-popup-headerr">
                <div className="success-icon">
                  <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 12l2 2 4-4"></path>
                    <circle cx="12" cy="12" r="10"></circle>
                  </svg>
                </div>
                <h3>Call Scheduled Successfully!</h3>
                <p>Your call has been scheduled. We will contact you soon.</p>
              </div>

              <div className="success-popup-actions">
                <button className="success-ok-btn" onClick={closeSuccessPopup}>
                  OK
                </button>
              </div>
            </div>
          </div>
        )}
      </div>




      {/* section 6 */}
      <div className="trend-main">
        <div className="trend">
          <div className="trend-1">
            <h2> Business Hours</h2>


            <div className="trend-2">
              <p>Monday - Friday: <span>9:00 AM - 6:00 PM IST</span></p>
              <p>Saturday: <span>10:00 AM - 04:00 PM IST</span></p>
              <p>Sunday:<span>Closed</span> </p>
            </div>
          </div>
        </div>
      </div>







      {/* section 6 */}
      <Cta />
      {/* <Footer /> */}
    </>
  )
}

export default Contact